import { render } from "./RadioButton.vue?vue&type=template&id=c4a73468&scoped=true"
import script from "./RadioButton.vue?vue&type=script&lang=js"
export * from "./RadioButton.vue?vue&type=script&lang=js"

import "./RadioButton.vue?vue&type=style&index=0&id=c4a73468&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4a73468"]])

export default __exports__